import { useLogger } from './useLogger'
import type { PresentationInstruction } from './PresentationInstruction'
import type { ResolverMap } from './ResolverMap'
import type { TranslateFn } from './TranslateFn'

const logger = useLogger('PresentationResolver')

export function resolveCode<C extends string>(
  instruction: PresentationInstruction<C>,
  map: ResolverMap<C>,
  t: TranslateFn
): string {
  const reasonTable = map.byReason[instruction.code]
  const reasonKey = instruction.reason !== undefined ? reasonTable?.[instruction.reason] : undefined

  // Warn only when the map declares reasons for this code but not this specific reason.
  if (instruction.reason !== undefined && reasonTable !== undefined && reasonKey === undefined) {
    logger.warn('resolveCodeReasonNotFound', { code: instruction.code, reason: instruction.reason })
  }

  const key = reasonKey ?? map.byCode[instruction.code] ?? map.genericKey

  return t(key, instruction.params)
}
